import { IEnvironment } from '@environments/IEnvironment';

export const featureFlags: IEnvironment['featureFlags'] = {
  isChatOnMainScreen: false,
  isCardEnabled: true,
  isInvestmentsEnabled: true,
  isLanguageSwitchEnabled: false,
  darkModeEnabled: true,
  dynamicAssets: false,
  isCgeNewsEnabled: false,
  isCashAccountSlideEnabled: true,
  isDepositaryBanksEnabled: false,
  eDocumentEnabled: true,
  restrictEDocumentForCRM: false,
  customEDocumentCategoryMapping: false,
  showEDocumentDocumentDate: false,
  showCashAccountDetails: false,
  showPerformanceOnPortfolioCard: false,
  showAssetPercentagesOnPortfolioCard: false,
  attachmentOverChatEnabled: true,
  showDebitedNetAmount: true,
  showSimAvailability: true,
  pdfOverChatEnabled: false,
  checkPaymentsAuthorized: false,
  forcedPickClientForRM: false,
  isClientSideSessionTimeoutEnabled: true,
  showPerformanceChartsAxis: false,
  useCumulativePerformanceLineChart: false
} as const;
